// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getQuoteDetail = async ({ ticketId, quoteId }) => {
  const data = await http.get(
    `${config.API_URL}price-negotiation/tickets/${ticketId}/quotes/${quoteId}/`
  );
  return data;
};

export default getQuoteDetail;
